<template>
  <span>
    <b-row>
      <b-col v-if="searchable !== undefined" class="my-1" md="4">
        <b-input-group>
          <b-form-input v-model="filter" placeholder="Recherche.." />
          <b-input-group-append>
            <b-btn :disabled="!filter" @click="filter = ''">Effacer</b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row @mouseleave="actionButtonsIndex = -10">
      <b-col sm>
        <b-table
          :current-page="currentPage"
          :fields="tableFields"
          :filter="getFilter"
          :items="tableData"
          :per-page="itemPerPage"
          bordered
          hover
          stacked="md"
          striped
          @row-hovered="toggleActionButtons"
        >
          <!-- Template pour la colorisation des type de catégorie -->
          <template #cell(coloredCategorie)="row">
            <span :class="categorieClass(row.item)">
              {{ row.item.categorie.libelle }}
            </span>
          </template>

          <!-- utilisé pour les adhérents -->
          <template #cell(beautifulAdresse)="row">
            {{ row.item.adresse }} {{ row.item.codePostal }}
            {{ row.item.ville }}
          </template>

          <!-- utilisé pour les référentiels -->
          <template #cell(libelleNonModifiable)="row">
            <span :class="!row.item.modifiable ? 'font-weight-bold' : ''">{{
              row.item.libelle
            }}</span>
          </template>

          <!-- Action possible sur la ligne -->
          <template #cell(Actions)="row">
            <span v-if="row.index == actionButtonsIndex" @click.stop>
              <font-awesome-icon
                v-if="viewSelector != undefined"
                class="pointer"
                icon="eye"
                @click.stop="onSelectView(row.item)"
              />
              <font-awesome-icon
                class="pointer ml-2"
                icon="edit"
                @click.stop="onSelectEdit(row.item)"
              />
              <font-awesome-icon
                v-b-modal.confirmDeleteModal
                class="pointer ml-2"
                icon="trash-alt"
                @click.stop="onSelectDelete(row.item)"
              />
            </span>
            <span v-else>
              <!-- bidouille pour pas que la tableau soit en "fixed" et qu'il ne bouge à l'affichage des icones d'actions
                                    on ajustera le nombre de a en fonction de la taille des icones-->
              <div class="transparentColor">aaaaaaaa</div>
            </span>
          </template>
        </b-table>
        <b-row v-if="tableData.length > itemPerPage">
          <b-col>
            <b-pagination
              v-model="currentPage"
              :per-page="itemPerPage"
              :total-rows="tableData.length"
              class="my-0"
            />
          </b-col>
          <b-col class="text-right">
            Nombre total d'éléments:&nbsp;
            <b> {{ tableData.length }}</b>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- Modal pour confirmer la suppression d'un élément du tableau -->
    <b-modal
      id="confirmDeleteModal"
      ref="confirmDeleteModal"
      centered
      title="Suppression"
      @hidden="selectedRowValue = {}"
    >
      <p class="my-4">
        {{ messageSuppression }}
        <strong>{{ libelleToDelete }}</strong>
      </p>
      <div slot="modal-footer" class="w-100">
        <b-button
          class="m-1 float-right"
          variant="primary"
          @click.stop="onConfirmDelete()"
          >Supprimer</b-button
        >
        <b-button
          class="m-1 float-right"
          type="cancel"
          variant="danger"
          @click.stop="onCancelDelete()"
          >Annuler
        </b-button>
      </div>
    </b-modal>
  </span>
</template>

<script>
import TypeLibelleService, {
  isCategorieDepense,
} from "../service/typeLibelleService";

export default {
  name: "CustomTab",
  props: [
    "tableFields",
    "tableData",
    "viewSelector",
    "messageSuppression",
    "libelleSuppressionProperty",
    "searchable",
    "customFilter",
  ],
  data() {
    return {
      //Object qui contient les libelle qui servent à comparer ("RECETTE", "DEPENSE", "DON"...)
      TypeLibelleService: TypeLibelleService,
      //Utilisé pour comparer l'index de la ligne du tableau actuel que l'utilisateur selectionne
      actionButtonsIndex: -10,
      //Valeur selectionné lors d'un clique sur une ligne du tableau
      selectedRowValue: {},

      libelleToDelete: "",

      //Filtre pour le tableau
      filter: "",

      itemPerPage: 20,

      currentPage: 1,
    };
  },
  methods: {
    onSelectView(item) {
      this.$emit("viewSelected", item);
    },
    onSelectDelete(item) {
      this.selectedRowValue = item;
      this.setSelectedDeleteLibelle();
      this.$bvModal.show("confirmDeleteModal");
    },
    onSelectEdit(item) {
      this.$emit("editSelected", item);
    },
    /**
     * Affecte l'index de la ligne du tableau de la variable actionButtonIndex
     */
    toggleActionButtons(item, index) {
      this.actionButtonsIndex = index;
    },
    /**
     * Cache la modal de confirmation de suppession
     */
    onCancelDelete() {
      this.$bvModal.hide("confirmDeleteModal");
    },
    /**
     * Envoi l'élémet à supprimer dans un evenement
     */
    onConfirmDelete() {
      this.$emit("deleteConfirmed", this.selectedRowValue);
      //On ferme la modal
      this.$bvModal.hide("confirmDeleteModal");
    },
    /**
     * Récupére le la propriété de l'objet à supprimer par introspection
     */
    setSelectedDeleteLibelle() {
      if (this.libelleSuppressionProperty && this.selectedRowValue) {
        for (var prop in this.selectedRowValue) {
          if (prop === this.libelleSuppressionProperty) {
            this.libelleToDelete = this.selectedRowValue[prop];
          }
        }
      }
    },
    categorieClass(item) {
      let classe = "";
      if (item.categorie) {
        classe = isCategorieDepense(item.categorie.typeSaisie)
          ? "text-success"
          : "text-danger";
      }
      return classe;
    },
  },
  computed: {
    getFilter() {
      if (this.customFilter != undefined) {
        return this.customFilter;
      } else {
        return this.filter;
      }
    },
  },
};
</script>
